// extracted by mini-css-extract-plugin
module.exports = {"page":"Library_page__ujwrv","heading":"Library_heading__Olgxt","folderHeader":"Library_folderHeader__vAmeI","tabs":"Library_tabs__WIM_n","actions":"Library_actions__IxlpF"};